import { StyledProps, x } from '@ui-furniture/style';

export const StackDivider = (props: StyledProps) => (
  <x.div
    borderRight='1px solid'
    borderTop='1px solid'
    borderColor='palette-border'
    {...props}
  />
);
